<script>
  let {
    header,
    content,
    input,
    maxWidth = 'var(--receipt-width)',
  } = $props();
</script>

<div class="receipt-page animate-page-in" style="--page-max-width: {maxWidth}">
  {#if header}
    <div class="receipt-page__header">
      {@render header()}
    </div>
  {/if}

  {#if content}
    <div class="receipt-page__content">
      {@render content()}
    </div>
  {/if}

  {#if input}
    <div class="receipt-page__input">
      {@render input()}
    </div>
  {/if}
</div>

<style>
  .receipt-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100dvh;
    max-width: var(--page-max-width);
    margin: 0 auto;
    padding: 24px 16px;
    background: var(--receipt-page-bg, #F0EDE8);
  }

  .receipt-page__header {
    width: 100%;
    flex-shrink: 0;
    margin-bottom: var(--receipt-section-gap, 16px);
  }

  .receipt-page__content {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .receipt-page__input {
    width: 100%;
    flex-shrink: 0;
    margin-top: var(--receipt-section-gap, 16px);
    position: sticky;
    bottom: 0;
    z-index: 10;
  }
</style>
